import React, { useState, useEffect } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_CLIENTS, AccountClient } from '@nile/graphql';
import Select from 'react-select';
import {
  DropdownIndicator,
  formatGroupLabel,
  IndicatorSeparator
} from '@nile/components/src/Pebbles/select';
import {
  getTranslatedText,
  useSiteListForDropdown,
  useProduct
} from '@nile/components';
import { isEmpty } from 'lodash';
import { FormattedMessage, useIntl } from 'react-intl';
import { ClientSiteFilterWrapper } from './style';
import { SVGIcon } from '@superops/super-icons';

function ClientSiteFilter(props) {
  const intl = useIntl();
  const isMSPProduct = useProduct('MSP');

  const { hideAgent, clientGet, siteGet, removeWhiteSpace } = props;

  const [clients, setClients] = useState([]);

  const [sites, setSites] = useState([]);

  const [selectedClient, setSelectedClient] = useState('');

  const [selectedSite, setSelectedSite] = useState(null);
  const { getClientSites, data } = useSiteListForDropdown();

  useEffect(() => {
    if (data) {
      const processedSites = data.map((site) => {
        return {
          label: site.name,
          value: site.name,
          ...site
        };
      });
      setSites(processedSites || []);
      if (props?.client) setSelectedSite(processedSites[0]);
    }
  }, [data]);

  const [fetchClients, { loading }] = useLazyQuery(GET_CLIENTS, {
    client: AccountClient,
    skip: !isMSPProduct,
    fetchPolicy: 'network-only',
    onCompleted: (res) => {
      const processedClients = res?.getClientList?.clients.map((client) => {
        return {
          label: client.name,
          value: client.name,
          ...client
        };
      });
      setClients(processedClients || []);
    }
  });

  useEffect(() => {
    fetchClients({
      variables: {
        listInfo: {
          sort: {
            attribute: 'name',
            order: 'ASC'
          }
        }
      }
    });
  }, []);

  const handleClientChange = (val) => {
    if (hideAgent) {
      clientGet(val);
    }
    setSelectedClient(val);
    setSelectedSite(null);
    if (hideAgent) {
      siteGet(null);
    }
    getClientSites(val.accountId);
  };

  useEffect(() => {
    if (!isEmpty(props?.client)) {
      handleClientChange({
        ...props.client,
        label: props.client.name,
        value: props.client.name
      });
    }
  }, [props?.client]);

  const handleSiteChange = (val) => {
    setSelectedSite(val);
    if (hideAgent) {
      siteGet(val);
    }
  };

  const defaultContent = (
    <ClientSiteFilterWrapper
      className={`${props?.fromOnboarding && 'min-height-auto'}`}
      removeWhiteSpace={removeWhiteSpace}
    >
      <div className="flex-row">
        <div className="client-block">
          <div className="select-label">
            <FormattedMessage id="rmm.downloadAgent.modal.clientHeader" />
          </div>
          <div className="flex-row flex-align-center">
            <div className="mr10 fx actr">
              <SVGIcon name="ClientLogo" />
            </div>
            <Select
              isLoading={loading}
              isClearable
              className="select-block"
              onChange={(val) => {
                handleClientChange(val);
              }}
              components={{
                IndicatorSeparator,
                DropdownIndicator
              }}
              classNamePrefix="value_selector"
              placeholder={getTranslatedText(
                intl,
                'rmm.agentDownload.modal.clientPlaceholder'
              )}
              formatGroupLabel={formatGroupLabel}
              menuPlacement="auto"
              menuPortalTarget={document.body}
              value={selectedClient}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 })
              }}
              options={clients}
            />
          </div>
        </div>

        <div
          className={
            isEmpty(selectedClient) ? 'disable-site site-block' : 'site-block'
          }
        >
          <FormattedMessage id="rmm.downloadAgent.modal.siteHeader" />
          <div className="select-label" />
          <div className="flex-row flex-align-center">
            <div className="mr10 fx actr">
              <SVGIcon name="Site" />
            </div>
            <Select
              className="select-block"
              isClearable
              onChange={(val) => {
                handleSiteChange(val);
              }}
              components={{
                IndicatorSeparator,
                DropdownIndicator
              }}
              classNamePrefix="value_selector"
              placeholder={getTranslatedText(
                intl,
                'rmm.agentDownload.modal.sitePlaceholder'
              )}
              formatGroupLabel={formatGroupLabel}
              menuPlacement="auto"
              value={selectedSite}
              menuPortalTarget={document.body}
              styles={{
                menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                menu: (base) => ({ ...base, zIndex: 9999 })
              }}
              options={sites}
            />
          </div>
        </div>
      </div>
    </ClientSiteFilterWrapper>
  );

  return <>{defaultContent}</>;
}

export default ClientSiteFilter;
